import { memo } from 'react'
import { Icon } from './Icon'

interface SearchClearButtonProps {
  onClear: () => void
}

export const SearchClearButton = memo(function SearchClearButton({
  onClear,
}: SearchClearButtonProps) {
  return (
    <button
      className="search-box-action search-clear-button"
      type="button"
      aria-label="Clear search"
      title="Clear search"
      onPointerDown={(event) => event.preventDefault()}
      onClick={onClear}
    >
      <Icon name="close" strokeWidth={2.4} />
    </button>
  )
})
